import React, { useEffect, useReducer } from "react";
import { Routes, Route, useSearchParams } from "react-router-dom";
import sensors from "sa-sdk-javascript";
import {
	Request,
	CTX_STATE,
	CTX_DISPATCH,
	creator,
	sysMsg,
	logOut,
	log,
	openBrowser,
	dateFormate,
	refreshUserInfo,
} from "./common";
import Home from "./Home";
import Store from "./view/Store";
import Wjyz from "./view/Wjyz";
import Search from "./view/Search";
import Goods from "./view/Goods";
import Personal from "./view/Personal";
import AllGame from "./view/AllGame";
import MemberGame from "./view/MemberGame";
import Modal from "./components/Modal";
import "antd/dist/reset.css";
import "./styles/scss/App.scss";

export default function App() {
	const [getPrama] = useSearchParams();

	const initStatus = {
		token: null,
		tokenProcess: 1,
		userInfo: null,
		loginIsShow: false,
		memberPayIsShow: false,
		reGetOnProcessGame: +new Date(),
		selectTimeIsShow: {
			isShow: false,
		},
		codeConvertIsShow: false,
		actShadowIsShow: false,
		startStepIsShow: false,
		updateProcessIsShow: {
			isShow: false,
		},
		kfIsShow: false,
		hasNetbarRight: false,
		globalMsg: "",
		actModalIsShow: false,
	};

	const reducer = (state, action) => {
		switch (action.type) {
			case "setToken": //是否登录的唯一标识，和客户端的token信息是一致的
				return {
					...state,
					token: action.payload,
				};
			case "setTokenProcess": //token获取验证过程 0：空闲 1：正在执行验证过程
				return {
					...state,
					tokenProcess: action.payload,
				};
			case "setUserInfo":
				return {
					...state,
					userInfo: action.payload,
				};
			case "setLoginIsShow": //是否展示登录框
				return {
					...state,
					loginIsShow: action.payload,
				};
			case "setMemberPayIsShow": //是否展示大会员充值
				return {
					...state,
					memberPayIsShow: action.payload,
				};
			case "setSelectTimeIsShow": //是否展示时间选择
				return {
					...state,
					selectTimeIsShow: action.payload,
				};
			case "setStartStepIsShow": //是否展示上号器
				return {
					...state,
					startStepIsShow: action.payload,
				};
			case "setCodeConvertIsShow": //是否展示口令兑换
				return {
					...state,
					codeConvertIsShow: action.payload,
				};
			case "setActShadowIsShow": //是否展示活动弹窗
				return {
					...state,
					actShadowIsShow: action.payload,
				};
			case "setUpdateProcessIsShow": //是否展示更新弹窗
				return {
					...state,
					updateProcessIsShow: action.payload,
				};
			case "setKfIsShow": //是否展示客服弹窗
				return {
					...state,
					kfIsShow: action.payload,
				};
			case "reGetOnProcessGame": //刷新上号游戏状态，触发hooks的副作用
				return {
					...state,
					reGetOnProcessGame: action.payload,
				};
			case "setHasNetbarRight": //是否有网吧特权
				return {
					...state,
					hasNetbarRight: action.payload,
				};
			case "setGlobalMsg": //全局提示
				return {
					...state,
					globalMsg: action.payload,
				};
			case "setActModalIsShow": //是否展示活动弹窗
				return {
					...state,
					actModalIsShow: action.payload,
				};
			default:
				console.log("unknown reducer");
				return {
					...state,
				};
		}
	};

	const [state, dispatch] = useReducer(reducer, initStatus);

	useEffect(() => {
		sensors.init({
			server_url:
				"https://sensorsdata.web.bigdata.fulu.com:8106/sa?project=yunshi_pro",
			is_track_single_page: true,
			use_client_time: true,
			send_type: "beacon",
			heatmap: {
				clickmap: "not_collect",
				scroll_notice_map: "default",
			},
		});
		sensors.registerPage({
			create_time: dateFormate("yyyy-MM-DD HH:mm:ss"),
			platform_type: "yizhan",
			pagetype: window.mbQuery ? "yizhan_client" : "yizhan_gw",
			label: window.mbQuery ? "PC_Client" : "PC_Web",
		});
		sensors.quick("autoTrack");

		if (window.mbQuery) {
			sensors.track("yizhan_client_initial", {
				status: 0,
				result: 1,
			});

			setTimeout(() => {
				sensors.track("yizhan_client_initial", {
					status: 1,
					result: 1,
				});
			});
		} else {
			//兼容网页 网页版没有header、我的游戏版块
			const styles = `
			  <style>
				html body #root {
				  padding-top: 0;
				}
		  
				html body #root .header {
				  display: none;
				}
		  
				html body #root .main .personal .nav div:first-child button:first-child {
				  display: none;
				}
			  </style>
			`;

			const head = document.getElementsByTagName("head")[0];
			head.insertAdjacentHTML("beforeend", styles);
		}

		const callback = (e) => {
			if (e.keyCode === 122) {
				e.preventDefault();
			} else if (e.shiftKey && e.keyCode === 123) {
				window.mbQuery?.showDevTools?.();
			}
		};

		document.addEventListener("keydown", callback, false);

		return () => {
			document.removeEventListener("keydown", callback, false);
		};
	}, []);

	useEffect(() => {
		if (!window.mbQuery) return;

		//热更新：校验版本更新
		const { version } = window.mbQuery?.appInfo || {};

		if (["1.0.0", "1.0.1", "1.0.2"].includes(version)) {
			Modal.tips({
				icon: "wanrning",
				contentHead: "版本过低",
				contentBody: "请下载最新版本",
				hideClose: true,
				onOk: (c) => {
					c();
					openBrowser("https://www.wanjiayizhan.com");
					window.mbQuery?.close?.();
				},
				okText: "立即下载",
				onCancel: (c) => {
					c();
					window.mbQuery?.close?.();
				},
				cancelText: "退出",
			});

			return;
		}

		window.mbQuery?.updateProcess?.((event, value) => {
			if (value === "failed") {
				dispatch(
					creator("setUpdateProcessIsShow", {
						isShow: false,
					})
				);
			} else {
				dispatch(
					creator("setUpdateProcessIsShow", {
						isShow: true,
						percent: value,
					})
				);
			}
		});

		const req = new Request({
			url: "/api/user/v1/check_ver",
			source: 2,
			data: {},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.base.code === "200" && res.data.version !== version) {
					window.mbQuery?.checkUpdates?.(res.data.updateUrl);
				}
			} catch (error) {
				sysMsg({
					msg: "校验客户端版本失败，请重新下载",
				});
				log(`校验版本更新错误`);
			}
		};

		getData();

		return () => {
			window.mbQuery?.removeUpdateProcess?.();
			req.cancel();
		};
	}, [dispatch]);

	useEffect(() => {
		const { channel_number: chanId } = window.mbQuery?.appInfo || {};

		const req = new Request({
			url: "/open-platform/pro/addInstall",
			source: 1,
			method: "post",
			data: {
				chanId,
			},
		});

		const getData = async () => {
			//获取用户已登录token
			try {
				//iframe中路由变化会刷新页面，所以url都需要携带token
				const token =
					(await window.mbQuery?.getToken?.()) || getPrama.get("token");

				const actShadow =
					(await window.mbQuery?.getActShadowIsShow?.()) ||
					window.localStorage.getItem("actShadowIsShow");

				if (!token && !actShadow) {
					dispatch(creator("setActShadowIsShow", true));
					window.mbQuery && req.send();
				}

				dispatch(creator("setToken", token));
			} catch (error) {
				log(`未获取到用户已登录token`);
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [getPrama, dispatch]);

	useEffect(() => {
		//验证token有效性
		if (!state.token) {
			dispatch(creator("setTokenProcess", 0));
			return;
		}

		const req = new Request({
			url: "/api/user/v1/infos",
			source: 2,
			headers: {
				token: state.token,
			},
			data: {},
		});

		const getData = async () => {
			try {
				const sensorsData = {
					logintype:
						(await window.mbQuery?.getToken?.()) || getPrama.get("token")
							? "auto"
							: "manual",
					supply: "msg",
				};

				if (window.mbQuery) {
					const appInfo = window.mbQuery?.appInfo || {};
					sensorsData.sid = appInfo.channel_number;
				}

				sensors.track("yizhan_login_process", {
					...sensorsData,
					status: 0,
				});

				let endSensorsData = {
					...sensorsData,
					status: 1,
				};

				const res = await req.send();
				if (res.base.code === "200") {
					dispatch(creator("setUserInfo", res.data));
					window.mbQuery?.setToken?.(state.token);

					if (res.data?.freeMinutes > 0) {
						Modal.tips({
							icon: "succ",
							contentHead: (
								<p>
									你已成功获得
									<span style={{ color: "#5DFE97" }}>
										{parseInt(res.data?.freeMinutes / 60)}小时大会员！
									</span>
								</p>
							),
							contentBody: "立即免费游玩全球好游戏~",
							onOk: (c) => {
								c();
							},
							okText: "好的",
							cancelBtn: null,
						});

						//赠送大会员时间导致有延迟
						refreshUserInfo(state.token, false, dispatch);
					}

					endSensorsData = {
						...endSensorsData,
						num: res.data?.id,
						result: "succes",
					};
				} else {
					logOut(dispatch);

					endSensorsData = {
						...endSensorsData,
						result: "fail",
						errorcode: res.base.code,
					};
				}

				sensors.track("yizhan_login_process", endSensorsData);
			} catch (error) {
				logOut(dispatch);
				log(`token验证接口错误`);
			}

			dispatch(creator("setTokenProcess", 0));
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [state.token, dispatch, getPrama]);

	useEffect(() => {
		if (!window.mbQuery) return;

		window.mbQuery?.modal?.((event, value) => {
			Modal.tips({
				icon: "warning",
				contentHead: value,
				contentBody: "",
				onOk: (c) => {
					c();
				},
				okText: "确定",
				cancelBtn: null,
			});
		});

		return () => {
			window.mbQuery?.removeModal?.();
		};
	}, []);

	useEffect(() => {
		if (!window.mbQuery) return;

		window.mbQuery?.updateOnProcessGame?.((event, value) => {
			dispatch(creator("reGetOnProcessGame", +new Date()));
		});

		return () => {
			window.mbQuery?.removeUpdateOnProcessGame?.();
		};
	}, [dispatch]);

	useEffect(() => {
		if (window.mbQuery?.appInfo?.type !== "netbar") return;

		window.mbQuery?.hasNetbarRight?.((event, value) => {
			state.hasNetbarRight !== value &&
				dispatch(creator("setHasNetbarRight", value));
		});

		return () => {
			window.mbQuery?.removeHasNetbarRight?.();
		};
	}, [state.hasNetbarRight, dispatch]);

	return (
		<CTX_STATE.Provider value={state}>
			<CTX_DISPATCH.Provider value={dispatch}>
				<Routes>
					<Route path="/" element={<Home />}>
						<Route path="Store" element={<Store />} />
						<Route path="Wjyz" element={<Wjyz />} />
						<Route path="Search/:key" element={<Search />} />
						<Route path="Goods" element={<Goods />} />
						<Route path="Personal/:nav" element={<Personal />} />
						<Route path="AllGame" element={<AllGame />} />
						<Route path="MemberGame" element={<MemberGame />} />
					</Route>
				</Routes>
			</CTX_DISPATCH.Provider>
		</CTX_STATE.Provider>
	);
}
